import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'NairoTube';
const SITE_URL = 'https://www.nairotube.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const normalizePath = (path = '/') => {
    if (!path || path === '/') return '/';
    return `/${path.replace(/^\/+|\/+$/g, '')}`;
};

const SEOHead = ({
    title,
    description,
    path = '/',
    image = DEFAULT_IMAGE,
    noIndex = false,
    breadcrumbs = [],
    includeOrganization = false
}) => {
    const normalizedPath = normalizePath(path);
    const canonical = `${SITE_URL}${normalizedPath}`;
    const fullTitle = title === SITE_NAME ? SITE_NAME : `${title} | ${SITE_NAME}`;
    const robots = noIndex
        ? 'noindex, nofollow, noarchive, nosnippet, noimageindex'
        : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

    const graph = [];

    if (includeOrganization) {
        graph.push(
            {
                '@type': 'Organization',
                '@id': `${SITE_URL}/#organization`,
                name: SITE_NAME,
                url: `${SITE_URL}/`,
                logo: {
                    '@type': 'ImageObject',
                    url: DEFAULT_IMAGE
                },
                contactPoint: {
                    '@type': 'ContactPoint',
                    contactType: 'customer support',
                    email: 'support@nairotube.com',
                    telephone: '+254745406125'
                }
            },
            {
                '@type': 'WebSite',
                '@id': `${SITE_URL}/#website`,
                name: SITE_NAME,
                url: `${SITE_URL}/`,
                publisher: { '@id': `${SITE_URL}/#organization` }
            }
        );
    }

    if (breadcrumbs.length > 0) {
        graph.push({
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: item.name,
                item: `${SITE_URL}${normalizePath(item.path)}`
            }))
        });
    }

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={robots} />
            <meta name="googlebot" content={robots} />
            {!noIndex && <link rel="canonical" href={canonical} />}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {graph.length > 0 && (
                <script type="application/ld+json">{JSON.stringify({ '@context': 'https://schema.org', '@graph': graph })}</script>
            )}
        </Helmet>
    );
};

export const PrivateSEOHead = ({ title = 'Private Content', path = '/' }) => (
    <SEOHead
        title={title}
        description="This page is private and is not available for search indexing."
        path={path}
        noIndex
    />
);

export default SEOHead;
